import { hFetch } from '@/lib/hfetch';
import type {
  CourseEntity,
  CourseSectionEntity,
  LectureAssetEntity,
  LectureEntity,
} from '@/api/entity_types/University';

export type LectureWithAssets = LectureEntity & { lecture_assets: LectureAssetEntity[]; completed: boolean };
export type SectionWithLectures = CourseSectionEntity & { lectures: LectureWithAssets[] };
export type CourseWithSections = CourseEntity & { course_sections: SectionWithLectures[] };
export type CourseListItem = CourseEntity & {
  sections_count: number;
  lectures_count: number;
  completed_lectures_count: number;
};

export const listCourses = async () => {
  return await hFetch<CourseListItem[]>({ url: '/api/agent/university_courses' });
};

export const getCourse = async (slug: string) => {
  return await hFetch<CourseWithSections>({ url: `/api/agent/university_courses/${slug}` });
};
